module.exports = __webpack_public_path__ + "img/Self-Empathy_new_logo.017480ae.png";